import { router } from '@booking-portal/router';
import type { App } from 'vue';

export function setupRouter(app: App) {
  app.use(router);
}
